import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { salesPopCities, salesPopNames } from '../data/salesPop';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/mSfcMCCEeNw9H1rYcX3LR3/mockupglucosaestable.png';
const START_DELAY = 21000;
const VISIBLE_MS = 3000;
const MIN_GAP_MS = 4000;
const MAX_GAP_MS = 10000;
interface SalesPop {
  id: number;
  name: string;
  city: string;
  minutes: number;
}
const randomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
const pick = <T,>(list: T[]) => list[Math.floor(Math.random() * list.length)];
export function SalesPopNotifications() {
  const [pop, setPop] = useState<SalesPop | null>(null);
  const reduceMotion = useReducedMotion();
  const counter = useRef(0);
  useEffect(() => {
    let showTimeout: number;
    let hideTimeout: number;
    const schedule = (delay: number) => {
      showTimeout = window.setTimeout(() => {
        counter.current += 1;
        setPop({
          id: counter.current,
          name: pick(salesPopNames),
          city: pick(salesPopCities),
          minutes: randomInt(1, 15)
        });
        hideTimeout = window.setTimeout(() => {
          setPop(null);
          schedule(randomInt(MIN_GAP_MS, MAX_GAP_MS));
        }, VISIBLE_MS);
      }, delay);
    };
    schedule(START_DELAY);
    return () => {
      window.clearTimeout(showTimeout);
      window.clearTimeout(hideTimeout);
    };
  }, []);
  return <div className="pointer-events-none fixed bottom-2 left-3 z-30 w-[calc(100%-1.5rem)] max-w-[320px] sm:bottom-6 sm:left-6 sm:max-w-[340px]" aria-live="polite" aria-atomic="true" data-id="element-34" data-mp="6ux681s0m37i">
      <AnimatePresence data-id="element-35" data-mp="3tzmv6esbetpp">
        {pop && <motion.div key={pop.id} className="flex items-center gap-3 rounded-xl border border-gold/40 bg-white/97 p-2.5 shadow-lift backdrop-blur sm:rounded-2xl sm:p-3" initial={reduceMotion ? undefined : {
        opacity: 0,
        x: -18,
        scale: 0.98
      }} animate={reduceMotion ? undefined : {
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={reduceMotion ? undefined : {
        opacity: 0,
        x: -14,
        scale: 0.98
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-36" data-mp="1w820s7zax21n">
            <img src={MOCKUP_URL} alt="" aria-hidden="true" className="h-10 w-10 shrink-0 rounded-lg object-cover sm:h-12 sm:w-12" width={96} height={96} loading="lazy" data-id="element-37" data-mp="3gqm7zima6p6e" />
            <div className="min-w-0" data-id="element-38" data-mp="3vdntxy1by41c">
              <p className="text-[0.8rem] leading-snug text-ink" data-id="element-39" data-mp="3vgtjtfhs99y4">
                <strong className="font-bold text-forest" data-id="element-40" data-mp="47cwebvj3ler">{pop.name}</strong> acaba de acceder al
                Método Glucosa Estable.
              </p>
              <p className="mt-1 flex items-center gap-1.5 text-[0.7rem] text-faint" data-id="element-41" data-mp="2oyn6yhua8w6w">
                <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-leaf" aria-hidden="true" data-id="element-42" data-mp="2owagthedffir" />
                {pop.city} · hace {pop.minutes} {pop.minutes === 1 ? 'minuto' : 'minutos'}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}